import { useMediaQuery } from "@uidotdev/usehooks";

export const useIsDesktop = () => useMediaQuery("(min-width: 768px)");
